import SimpleHomeBreadcrumb from '@Components/Shared/SimpleHomeBreadcrumb';
import SiteMapLinks from '@Components/Shared/SiteMapLinks';

const SiteMapView = (props) => {
    return (
        <div className='info-content-container'>
            <div className='info-content-header'>
                <SimpleHomeBreadcrumb homeRoute={props.BreadCrumbHomeRoute} displayText={props.BreadCrumbText} />
                {props.HeadingText &&
                    <h1 className='center-text main-terms__heading'>{props.HeadingText}</h1>
                }
            </div>
            <div className='site-map-container'>
                <SiteMapLinks {...props} />
            </div>
        </div>
    );
};

export default SiteMapView;
global.SiteMapView = SiteMapView;